import type { FC } from 'react'
import React from 'react'
import { Typography, useTheme } from '@mui/material'
import Avatar from '../Avatar'
import { Container, TextWrapper } from './styles'
import type { CmsHistoryContentProps } from './types'
import useCmsContentHistory from './use-cms-content-history'

const CmsContentHistory: FC<CmsHistoryContentProps> = (props) => {
  const { palette } = useTheme()
  const { avatar, translations, t, history, timeAt } = useCmsContentHistory(props)
  const { title, date } = translations
  const { userFirstName, userLastName } = history

  if (!avatar) return null

  return (
    <Container>
      <Avatar src={avatar.avatarUrl} size={5} text={avatar.avatarName} />
      <TextWrapper>
        <Typography variant="body1">{`${t(title)} ${userFirstName ?? ''} ${userLastName ?? ''}`}</Typography>
        <Typography variant="body1" color={palette.text.secondary}>
          {`${t(date)} ${timeAt}`}
        </Typography>
      </TextWrapper>
    </Container>
  )
}

export default CmsContentHistory
